<template>
  <div class="full-page" :style="{ backgroundImage: `url(${require('@/assets/bg.png')})` }">
    <v-container fill-height fluid class="pa-0 ma-0">
      <v-row class="fill-height pa-0 ma-0" justify="center" align="end">
        <v-col cols="12" md="6" class="pa-0">
          <v-card class="register-card" transition="scale-transition">
            <div class="card-header">
              <img src="@/assets/logo.png" class="logo-image fade-in" alt="Logo" />
              <div class="login-text montserrat-title fade-in">REGISTER</div>
              <v-btn icon @click="goToPage('/')" class="back-button fade-in">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="text-center">
                <v-alert
                  v-if="alert.visible"
                  :type="alert.type"
                  dismissible
                  class="mb-4 montserrat-alert fade-in"
                  @input="alert.visible = false"
                >
                  {{ alert.message }}
                </v-alert>
                <v-text-field
                  v-model="fullName"
                  label="Full Name"
                  solo
                  rounded
                  class="my-4 montserrat-input fade-in"
                  hide-details
                  prepend-inner-icon="mdi-account"
                ></v-text-field>
                <v-select
                  v-model="role"
                  :items="roles"
                  label="Role"
                  solo
                  rounded
                  class="my-4 montserrat-input fade-in"
                  hide-details
                  prepend-inner-icon="mdi-account-box"
                ></v-select>
                <v-select
                  v-model="group"
                  :items="groups"
                  label="Group"
                  solo
                  rounded
                  class="my-4 montserrat-input fade-in"
                  hide-details
                  prepend-inner-icon="mdi-account-group"
                ></v-select>
                <v-text-field
                  v-model="email"
                  label="Email"
                  solo
                  rounded
                  class="my-4 montserrat-input fade-in"
                  hide-details
                  prepend-inner-icon="mdi-email"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  label="Password"
                  solo
                  rounded
                  class="my-4 montserrat-input fade-in"
                  hide-details
                  type="password"
                  prepend-inner-icon="mdi-lock"
                ></v-text-field>
                <v-text-field
                  v-model="confirmPassword"
                  label="Confirm Password"
                  solo
                  rounded
                  class="my-4 montserrat-input fade-in"
                  hide-details
                  type="password"
                  prepend-inner-icon="mdi-lock-check"
                ></v-text-field>
                <v-row>
                  <v-col cols="6">
                    <v-switch
                      v-model="permission1"
                      label="JOBS"
                      class="my-4 montserrat-input fade-in"
                    ></v-switch>
                  </v-col>
                  <v-col cols="6">
                    <v-switch
                      v-model="permission2"
                      label="FUNCTIONS"
                      class="my-4 montserrat-input fade-in"
                    ></v-switch>
                  </v-col>
                  <v-col cols="6">
                    <v-switch
                      v-model="permission3"
                      label="Purchase Order"
                      class="my-4 montserrat-input fade-in"
                    ></v-switch>
                  </v-col>
                  <v-col cols="6">
                    <v-switch
                      v-model="permission4"
                      label="Returns"
                      class="my-4 montserrat-input fade-in"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-btn dark rounded large width="100%" color="#991d23" @click="submit" class="montserrat-button fade-in">
                  <v-icon left>mdi-account-plus</v-icon>Register
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { firebaseApp } from "@/firebaseConfig";

export default {
  data() {
    return {
      fullName: '',
      role: '',
      roles: ['Sales', 'Workshop', 'Designer', 'Admin'],
      group: '',
      groups: ['Group 1', 'Group 2', 'Group 3', 'Group 4', 'Group 5'],
      email: '',
      password: '',
      confirmPassword: '',
      permission1: false,
      permission2: false,
      permission3: false,
      permission4: false,
      alert: {
        visible: false,
        message: '',
        type: 'success'
      }
    };
  },
  methods: {
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    validatePassword(password) {
      const hasUpperCase = /[A-Z]/.test(password);
      const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(password);
      const isValidLength = password.length > 6;
      return hasUpperCase && hasSpecialCharacter && isValidLength;
    },
    async submit() {
      if (this.password !== this.confirmPassword) {
        this.alert = { visible: true, message: "Passwords do not match!", type: 'error' };
        return;
      }

      if (!this.validateEmail(this.email)) {
        this.alert = { visible: true, message: "Invalid email address!", type: 'error' };
        return;
      }

      if (!this.validatePassword(this.password)) {
        this.alert = {
          visible: true,
          message: "Password must be greater than 6 characters, contain at least one capital letter and one special character!",
          type: 'error'
        };
        return;
      }

      const auth = getAuth(firebaseApp);
      const db = getFirestore(firebaseApp);

      try {
        const userCredential = await createUserWithEmailAndPassword(auth, this.email, this.password);
        const user = userCredential.user;

        await setDoc(doc(db, "users", user.uid), {
          userID: user.uid,
          fullName: this.fullName,
          role: this.role,
          group: this.group,
          email: this.email,
          
          createdAt: new Date()
        });

        this.alert = { visible: true, message: "User registered successfully!", type: 'success' };
      } catch (error) {
        this.alert = { visible: true, message: `Error: ${error.message}`, type: 'error' };
      }
    },
    goToPage(page) {
      this.$router.push(page);
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');

.full-page {
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.full-page::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.register-card {
  position: relative;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 20px 20px 0px 0px;
  overflow: hidden;
  height: 70%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  transition: all 0.3s ease-in-out;
}

.card-header {
  background-color: #f0f0f0;
  border-bottom: 1px solid #ddd;
  padding: 20px;
  text-align: center;
  position: relative;
}

.back-button {
  position: absolute;
  top: 10px;
  right: 10px;
}

.text-center {
  text-align: center;
}

.logo-image {
  width: 200px;
  height: auto;
  margin-bottom: 20px;
}

.my-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.montserrat-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  animation: fadeIn 1s ease-in-out;
}

.montserrat-input {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  animation: fadeIn 1.2s ease-in-out;
}

.montserrat-button {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  animation: fadeIn 1.4s ease-in-out;
}

.montserrat-alert {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  animation: fadeIn 0.8s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 1s ease-in-out;
}

.scale-transition {
  transition: transform 0.3s ease-in-out;
  transform: scale(0.95);
}

.scale-transition-enter-active,
.scale-transition-leave-active {
  transition: transform 0.3s ease-in-out;
}

.scale-transition-enter, 
.scale-transition-leave-to {
  transform: scale(1);
}
</style>
